import type { ButtonProps } from '../primitives/button.js'
import type { BaseLayoutSpec } from '@tunasong/plugin-lib'
import type { FC } from 'react'
import { MenuButtonSelector } from '../menu/menu-button.js'

export interface LayoutSelectorProps extends Omit<ButtonProps, 'onChange'> {
  layouts: BaseLayoutSpec[]
  selected?: BaseLayoutSpec
  onChange(layout: BaseLayoutSpec): void
}

export const LayoutSelector: FC<LayoutSelectorProps> = props => {
  const { layouts, selected, onChange, ...restProps } = props

  return <MenuButtonSelector items={layouts} onChange={onChange} selected={selected} {...restProps} />
}

export default LayoutSelector
